import { render, staticRenderFns } from "./createUser.vue?vue&type=template&id=76444026&scoped=true&"
import script from "./createUser.vue?vue&type=script&lang=js&"
export * from "./createUser.vue?vue&type=script&lang=js&"
import style0 from "./createUser.vue?vue&type=style&index=0&id=76444026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76444026",
  null
  
)

export default component.exports